<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm ts-uppercase">
          {{ $t('product.exportProductPrice') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">{{
                  $t('product.branchName')
                }}</label>
                <div>
                  <a-select
                    v-model="model.branch_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('product.branchName')"
                    :options="branchProfiles"
                  >
                  </a-select>

                  <div class="ts-text-red-500" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button class="btn-sm" @click.prevent="$emit('close')">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                color="primary"
                class="ml-2 btn-sm"
                :waiting="saving"
                @click.prevent="onExport"
                >{{ $t('export') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
export default {
  props: ['data'],
  name: 'exportProductPrice',
  data() {
    return {
      branches: [],
      loading: false,
      saving: false,
      errors: new Errors(),
      model: {
        branch_id: []
      }
    }
  },
  computed: {
    branchProfiles() {
      return this.branches.map(item => ({
        value: item.branch_id,
        label: item.branch_name_en
      }))
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('product', ['exportProductPrice', 'getBranch']),

    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data
      })
      this.loading = false
    },
    onExport() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('product/exportProductPrice', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'.indexOf('filename')]
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)

          this.$emit('before-close')
          this.$emit('close')
          this.saving = false
        })
        .catch(error => {
          let err = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          console.log(err);
          this.$toasted.error(err.message)
          this.errors = new Errors(err.errors)
        })
        .finally(() => (this.saving = false))
    }
  }
}
</script>
